import { render, staticRenderFns } from "./Clue.vue?vue&type=template&id=cabe813c&scoped=true&"
import script from "./Clue.vue?vue&type=script&lang=ts&"
export * from "./Clue.vue?vue&type=script&lang=ts&"
import style0 from "./Clue.vue?vue&type=style&index=0&id=cabe813c&lang=scss&scoped=true&"
import style1 from "./Clue.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabe813c",
  null
  
)

export default component.exports